import { render, staticRenderFns } from "./DataTabContent.vue?vue&type=template&id=49f44a90&scoped=true&"
import script from "./DataTabContent.vue?vue&type=script&lang=js&"
export * from "./DataTabContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f44a90",
  null
  
)

export default component.exports